/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import { Filter } from 'lucide-react';

function FilterModal({
  handleSearch, teams, members, pending, defaultMemberId = 0, isActive = false,
}) {
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [teamId, setTeamId] = useState(0);
  const [memberId, setMemberId] = useState(defaultMemberId);

  const openFilter = Boolean(filterAnchorEl);
  const popoverId = openFilter ? 'reports-filter-popover' : undefined;

  const handleReset = () => {
    setTeamId(0);
    setMemberId(0);
    handleSearch(0, 0);
  };

  const clickSearch = () => {
    handleSearch(teamId, memberId);
    setFilterAnchorEl(null);
  };

  return (
    <div>
      <button
        type="button"
        onClick={(e) => setFilterAnchorEl(e.currentTarget)}
        className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition h-10 whitespace-nowrap ${
          isActive
            ? 'bg-[#53A551] text-white hover:bg-[#458a44]'
            : 'bg-brand-700 text-white hover:bg-[#1a2f52]'
        }`}
      >
        <Filter size={14} />
        Filters
      </button>
      <Popover
        id={popoverId}
        open={openFilter}
        anchorEl={filterAnchorEl}
        onClose={() => setFilterAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              borderRadius: '12px',
              boxShadow: '0 8px 24px rgba(14,30,64,0.08)',
              border: '1px solid #E0E1E6',
            },
          },
        }}
      >
        <div className="w-[320px] max-w-[92vw] p-4 bg-white">
          <h4 className="text-sm font-semibold text-ink-900 mb-3">Filters</h4>
          <div className="space-y-3">
            <div>
              <label
                htmlFor="reports-team-filter"
                className="block text-[11px] uppercase tracking-wider text-ink-500 font-semibold mb-1.5"
              >
                Team Name
              </label>
              <select
                id="reports-team-filter"
                value={teamId}
                onChange={(e) => {
                  setTeamId(Number(e.target.value));
                  setMemberId(0);
                }}
                className="w-full px-3 py-2 border border-rule rounded-[8px] text-sm bg-white text-ink-900 focus:outline-none focus:border-brand-500"
              >
                <option value={0}>All</option>
                {teams.map((item) => (
                  <option key={item.id} value={item.id}>{item.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label
                htmlFor="reports-member-filter"
                className="block text-[11px] uppercase tracking-wider text-ink-500 font-semibold mb-1.5"
              >
                Member Name
              </label>
              <select
                id="reports-member-filter"
                value={memberId}
                onChange={(e) => setMemberId(Number(e.target.value))}
                className="w-full px-3 py-2 border border-rule rounded-[8px] text-sm bg-white text-ink-900 focus:outline-none focus:border-brand-500"
              >
                <option value={0}>All</option>
                {members.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.user?.firstName}
                    {' '}
                    {item.user?.lastName}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex items-center justify-end gap-2 pt-2">
              <button
                type="button"
                onClick={handleReset}
                className="px-3 py-1.5 text-sm text-ink-900 hover:text-brand-700 transition"
              >
                Reset
              </button>
              <button
                type="button"
                onClick={clickSearch}
                disabled={pending?.teams || pending?.members}
                className="px-4 py-1.5 bg-[#53A551] text-white rounded-[8px] text-sm font-medium hover:bg-[#458a44] transition disabled:opacity-60"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </Popover>
    </div>
  );
}

export default FilterModal;
